/**
 * "Listening…" indicator — shown in place of the AI caption while the
 * participant is talking. Five staggered animated bars + a label.
 * Verbatim port from the prototype.
 */
export function Listening() {
  const delays = [0, 110, 220, 110, 0];
  return (
    <div className="flex items-center justify-center gap-3 h-full">
      <div className="flex items-end gap-[3px] h-5">
        {delays.map((delay, i) => (
          <span
            key={i}
            className="w-[3px] h-full rounded-full bg-brand-700 origin-center animate-listening-bar"
            style={{ animationDelay: `${delay}ms` }}
          />
        ))}
      </div>
      <span className="text-[15px] sm:text-[17px] font-medium text-brand-700">
        Listening…
      </span>
    </div>
  );
}
